import { useRouter } from 'next/router'

import Button from '@/atoms/Button/Button'

function ResetButton() {
  const router = useRouter()

  const resetFilters = () =>
    router.push(
      {
        pathname: window.location.pathname,
        query: router.query?.q ? { q: router.query?.q } : {},
      },
      undefined,
      {
        shallow: true,
      }
    )

  return (
    <Button
      className="px-3 py-1.5"
      text="Wyczyść filtry"
      variant="flat-outline"
      onClick={resetFilters}
    />
  )
}

export default ResetButton
